import * as htmlparser from "htmlparser2";

import {rpAppLink} from "@pg-mono/rp-routes";

import {createOfferLink} from "../../offer/helpers/create_offer_link";
import {buildFriendlyOfferListLink} from "../../offer/helpers/friendly_offer_list/build_friendly_offer_list_link";
import {IArticleDetailRelation} from "../actions/IArticleDetail";
import {getRelatedPhraseRegex} from "./get_related_phrase_regex";

export const bindRelatedPhrasesToText = (phraseRelations: IArticleDetailRelation[], text: string): string => {
    let result = text;

    phraseRelations.forEach((relation) => {
        if (!relation.phrase) {
            return;
        }

        const phraseRegex = getRelatedPhraseRegex(relation.phrase);

        // Phrase regex is null, so we are not able to bind any text to this phrase - return
        if (phraseRegex === null) {
            return;
        }

        if (relation.related_article != null) {
            const url = rpAppLink.article.detail({
                articleSlug: relation.related_article.slug,
                articleId: relation.related_article.id
            });
            result = renderLinkInText(result, phraseRegex, url);
        }

        if (relation.related_vendor != null) {
            const url = rpAppLink.vendor.detail.base({
                vendorSlug: relation.related_vendor.slug,
                vendorId: relation.related_vendor.id
            });
            result = renderLinkInText(result, phraseRegex, url);
        }

        if (relation.related_offer != null) {
            const url = createOfferLink(relation.related_offer);
            result = renderLinkInText(result, phraseRegex, url);
        }

        if (relation.related_search_region != null) {
            const url = buildFriendlyOfferListLink({region: relation.related_search_region.slug});
            result = renderLinkInText(result, phraseRegex, url);
        }

        if (relation.related_url != null) {
            result = renderLinkInText(result, phraseRegex, relation.related_url);
        }
    });

    return result;
};

function renderLinkInText(inputArticleText: string, phraseRegex: RegExp, url: string): string {
    let articleText = inputArticleText;
    let foundPhraseCount = 0;
    let previousTextEndIndex = 0;
    const tagStack: string[] = [];

    const parser = new htmlparser.Parser(
        {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            onopentag: (name: string, attribs: {[p: string]: string}) => {
                tagStack.push(name);
            },
            ontext: (text: string) => {
                // Don't bind phrases in links (`a`) and headlines (`hn`)
                if (tagStack.some((tag) => ["a", "h1", "h2", "h3", "h4", "h5", "h6"].includes(tag))) {
                    return;
                }

                let begin = articleText.slice(previousTextEndIndex).indexOf(text);

                if (begin !== -1) {
                    begin = begin + previousTextEndIndex;
                }

                const end = begin === -1 ? -1 : Math.min(begin + text.length, articleText.length);

                if (begin === -1 || end === -1) {
                    return;
                }

                /*
                 * We need to track when previous text fragment (argument passed to the `ontext` method) ends.
                 * This value will be the start point for article text parsing. This action will prevent a situation,
                 * when `text` will be found in article text, which was already parsed. This may be a common situation,
                 * especially when `text` will be a single word.
                 */
                previousTextEndIndex = end;

                const matched = text.match(phraseRegex);
                const matchBegin = matched && matched.index;
                const matchPhrase = matched && matched[0];
                if (matchBegin == null || matchPhrase == null) {
                    return;
                }

                // update articleText
                const beginPhrase = matchBegin + begin;
                if (beginPhrase >= 0 && beginPhrase < end) {
                    const endPhrase = beginPhrase + matchPhrase.length;
                    const articleTextBeforePhrase = articleText.slice(0, beginPhrase);
                    const articleTextAfterPhrase = articleText.slice(endPhrase);
                    const replacement = foundPhraseCount === 0 ? `<a href="${url}" target="_blank" rel="dofollow noopener">${matchPhrase}</a>` : matchPhrase;
                    articleText = articleTextBeforePhrase + replacement + articleTextAfterPhrase;
                    foundPhraseCount++;
                }
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            onclosetag: (tagname: string) => {
                tagStack.pop();
            }
        },
        {decodeEntities: false, lowerCaseTags: true, recognizeSelfClosing: true}
    );
    parser.write(articleText);
    return articleText;
}
import * as htmlparser from "htmlparser2";

import {rpAppLink} from "@pg-mono/rp-routes";

import {createOfferLink} from "../../offer/helpers/create_offer_link";
import {buildFriendlyOfferListLink} from "../../offer/helpers/friendly_offer_list/build_friendly_offer_list_link";
import {IArticleDetailRelation} from "../actions/IArticleDetail";
import {getRelatedPhraseRegex} from "./get_related_phrase_regex";

export const bindRelatedPhrasesToText = (phraseRelations: IArticleDetailRelation[], text: string): string => {
    let result = text;

    phraseRelations.forEach((relation) => {
        if (!relation.phrase) {
            return;
        }

        const phraseRegex = getRelatedPhraseRegex(relation.phrase);

        // Phrase regex is null, so we are not able to bind any text to this phrase - return
        if (phraseRegex === null) {
            return;
        }

        if (relation.related_article != null) {
            const url = rpAppLink.article.detail({
                articleSlug: relation.related_article.slug,
                articleId: relation.related_article.id
            });
            result = renderLinkInText(result, phraseRegex, url);
        }

        if (relation.related_vendor != null) {
            const url = rpAppLink.vendor.detail.base({
                vendorSlug: relation.related_vendor.slug,
                vendorId: relation.related_vendor.id
            });
            result = renderLinkInText(result, phraseRegex, url);
        }

        if (relation.related_offer != null) {
            const url = createOfferLink(relation.related_offer);
            result = renderLinkInText(result, phraseRegex, url);
        }

        if (relation.related_search_region != null) {
            const url = buildFriendlyOfferListLink({region: relation.related_search_region.slug});
            result = renderLinkInText(result, phraseRegex, url);
        }

        if (relation.related_url != null) {
            result = renderLinkInText(result, phraseRegex, relation.related_url);
        }
    });

    return result;
};

function renderLinkInText(inputArticleText: string, phraseRegex: RegExp, url: string): string {
    let articleText = inputArticleText;
    let foundPhraseCount = 0;
    let previousTextEndIndex = 0;
    const tagStack: string[] = [];

    const parser = new htmlparser.Parser(
        {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            onopentag: (name: string, attribs: {[p: string]: string}) => {
                tagStack.push(name);
            },
            ontext: (text: string) => {
                // Don't bind phrases in links (`a`) and headlines (`hn`)
                if (tagStack.some((tag) => ["a", "h1", "h2", "h3", "h4", "h5", "h6"].includes(tag))) {
                    return;
                }

                let begin = articleText.slice(previousTextEndIndex).indexOf(text);

                if (begin !== -1) {
                    begin = begin + previousTextEndIndex;
                }

                const end = begin === -1 ? -1 : Math.min(begin + text.length, articleText.length);

                if (begin === -1 || end === -1) {
                    return;
                }

                /*
                 * We need to track when previous text fragment (argument passed to the `ontext` method) ends.
                 * This value will be the start point for article text parsing. This action will prevent a situation,
                 * when `text` will be found in article text, which was already parsed. This may be a common situation,
                 * especially when `text` will be a single word.
                 */
                previousTextEndIndex = end;

                const matched = text.match(phraseRegex);
                const matchBegin = matched && matched.index;
                const matchPhrase = matched && matched[0];
                if (matchBegin == null || matchPhrase == null) {
                    return;
                }

                // update articleText
                const beginPhrase = matchBegin + begin;
                if (beginPhrase >= 0 && beginPhrase < end) {
                    const endPhrase = beginPhrase + matchPhrase.length;
                    const articleTextBeforePhrase = articleText.slice(0, beginPhrase);
                    const articleTextAfterPhrase = articleText.slice(endPhrase);
                    const replacement = foundPhraseCount === 0 ? `<a href="${url}" target="_blank" rel="dofollow noopener">${matchPhrase}</a>` : matchPhrase;
                    articleText = articleTextBeforePhrase + replacement + articleTextAfterPhrase;
                    foundPhraseCount++;
                }
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            onclosetag: (tagname: string) => {
                tagStack.pop();
            }
        },
        {decodeEntities: false, lowerCaseTags: true, recognizeSelfClosing: true}
    );
    parser.write(articleText);
    return articleText;
}
